"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openUrl = openUrl;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _docsUserAgent = _interopRequireDefault(require("@tencent/docs-user-agent"));
var isQQ = _docsUserAgent.default.isQQ,
  isTim = _docsUserAgent.default.isTim,
  isIOS = _docsUserAgent.default.isIOS,
  isTencentDocsApp = _docsUserAgent.default.isTencentDocsApp,
  isQQMiniProgram = _docsUserAgent.default.isQQMiniProgram;
function emptyFunc() {}
function openUrl(url) {
  var openUrlParams = {
    url: url,
    target: 1,
    style: 2
  };
  var openLinkParams = {
    url: url
  };
  var mqq = window.mqq;
  if (isTencentDocsApp && mqq) {
    // jsbridge://nav/openLinkInNewWebView?
    if (isIOS) {
      mqq.invoke('nav', 'openLinkInNewWebView', openLinkParams, emptyFunc);
    } else {
      mqq.invoke('ui', 'openUrl', openUrlParams, emptyFunc);
    }
    return;
  }
  // TIM 下比较特殊，得这样
  if ((isQQ || isTim) && mqq && !isQQMiniProgram) {
    // checkIsQQTim

    if (isQQ) {
      // checkIsQQ
      mqq.invoke('ui', 'openUrl', openUrlParams, emptyFunc);
    } else {
      // TIM ?
      if (isIOS) {
        mqq.invoke('nav', 'openLinkInNewWebView', openLinkParams, emptyFunc);
      } else {
        mqq.invoke('ui', 'openUrl', (0, _objectSpread2.default)((0, _objectSpread2.default)({}, openUrlParams), {}, {
          useQQBrowser: true
        }), emptyFunc);
      }
    }
  } else {
    (window.top || window).location.href = url;
  }
}